import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

export interface AlertMessage {
  type: 'success' | 'warning' | 'critical';
  message: string;
  marginTop: number; // Optional property for custom margin
}

@Injectable({
  providedIn: 'root',
})
export class AlertService {
  private alertSubject = new Subject<AlertMessage>();
  alert$ = this.alertSubject.asObservable();

  showAlert(
    message: string,
    type: 'success' | 'warning' | 'critical' = 'success',
    marginTop: number = 76,
  ) {
    this.alertSubject.next({ type, message, marginTop });
  }
}
